export interface Sponsor {
  name: string;
  logoUrl: string;
  websiteUrl: string;
}

export const sponsors: Sponsor[] = [
  {
    name: 'Takeda',
    logoUrl: '/assets/images/sponsors/takeda-3.png',
    websiteUrl: 'https://www.takedaoncology.com/',
  },
  {
    name: 'Lend a Hand Global',
    logoUrl: '/assets/images/sponsors/LAHG.svg',
    websiteUrl: 'https://lendahandglobal.com/',
  },
];
